<template>
    <div class="fire-control-table">
        <el-table :border="true" :data="tableData">
            <el-table-column prop="fireZoneCode" label="消防分区编码" :show-overflow-tooltip="true" width="140"></el-table-column>
            <el-table-column prop="fireZoneName" label="消防分区名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="fireZoneSquare" label="面积(四面墙内实际可用面积/㎡)" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="nakedRentalArea" label="裸租面积(㎡)" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="fireZoneContractStatus" label="合同状态" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <mSelect class="contract-status--column" :optionNum="'PHY_WH_CONTRACT_STATUS'" :value="scope.row.fireZoneContractStatus" :placeholder="''"
                        :filterable="false" :disabled="true" />
                </template>
            </el-table-column>
            <el-table-column prop="enableLease" label="当前是否可租" :show-overflow-tooltip="true" width="120">
                <template slot-scope="scope">
                    <mSelect class="contract-status--column" :optionNum="'SRM_PHY_WH_ENABLE_LEASE'" :value="scope.row.enableLease" :placeholder="''"
                        :filterable="false" :disabled="true" />
                </template>
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true"  width="160"></el-table-column>
            <el-table-column prop="updateUserName" label="修改人" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" :show-overflow-tooltip="true" width="160"></el-table-column>
            <el-table-column label="操作" width="50">
                <template slot-scope="scope">
                    <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <m-page ref="page" :current-page="currentPage" :pageData="pageData" :total="total"
            @on-page-change="pageChange" @on-size-change="sizeChange"></m-page> -->
        <fire-control-dialog ref="fireControl" @refresh="handleRefresh" />
    </div>
</template>
<script>
// import mPage from '@/components/supplierPanel/mPage';
import mSelect from '../../../../../components/Select.vue';
import FireControlDialog from './FireControlDialog.vue';
import { getFireZones } from '../../../../../api/addPhysicalStorage.js';

export default {
    name: 'fireControlTable',
    components: { mSelect, FireControlDialog },
    props: {
        sonWhCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            loading: false,
            tableData: []
            // total: 0,
            // currentPage: 1,
            // pageData: {
            //     pageSize: 10,
            //     pageSizes: [10, 20, 50],
            //     layout: 'total, sizes, prev, pager, next'
            // }
        };
    },
    methods: {
        // pageChange(data) {
        //     this.currentPage = data;
        //     this.getList();
        // },
        // sizeChange(data) {
        //     this.pageData.pageSize = data;
        //     this.getList();
        // },
        getList() {
            getFireZones({
                sonWhCode: this.sonWhCode,
                pageNo: 1,
                pageSize: 10000
            }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list;
                    this.total = res.data.totalCount;
                }
            });
        },
        handleEdit(row) {
            this.$refs.fireControl.openToEdit(row);
        },
        handleRefresh(whCode) {
            this.$emit('refresh', whCode);
        }
    },
    mounted() {
        this.getList();
    }
};
</script>
<style lang="less">
    .fire-control-table {
        width: 1200px;

        .el-table {
            margin-bottom: 10px;
        }

        .contract-status--column {
            .el-input.is-disabled .el-input__inner {
                color: #666;
                background-color: white;
                border: none;
                cursor: initial;
            }

            .el-input__suffix {
                display: none;
            }
        }
    }
</style>